var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h5',{staticStyle:{"color":"#ffffff"}},[_vm._v(" 请输入正确链接地址")])])}]

export { render, staticRenderFns }